// ===============================================================================
//
// Handles the fetching of any selected inventories in local storage.
// WARNING: to prevent the reading of "stale" selected inventories, the manager
// clears the selected inventories after reading it
//

export class SelectedInventoriesManager {

    // ===============================================================================

    private static readonly _localStorageInventoriesKeyPrefix = "selected-inventories-";
    private static readonly _localStorageHeaderKey = "select-inventories-localized-header";

    // ===============================================================================

    /**
     * Gets selected inventories from the Select Inventories page that were stores in local storage.
     * After getting said inventories, the local storage is cleared to prevent "stale" inventories from
     * being read.
     */
    public static getThenClearSelectedInventorieFromLocalStorage(userIdThatSelectedInventories: string): string[] | null {
        const key = this._localStorageInventoriesKeyPrefix + userIdThatSelectedInventories;

        const selectedInventoriesJson = localStorage.getItem(key);

        // No selected inventories for that user was found.
        if (selectedInventoriesJson === null) {
            return null;
        }

        try {
            const selectedInventories = JSON.parse(selectedInventoriesJson) as string[];
            localStorage.removeItem(key);

            return selectedInventories;
        }
        catch {
            console.error("Failed to get selected inventories.");
            return null;
        }
    }

    // ===============================================================================

    /**
     * Stores the necessary data for selecting inventories into local storage.
     */
    private static storeDataInLocalStorage(localizedHeader?: string) {
        if (localizedHeader) {
            localStorage.setItem(this._localStorageHeaderKey, localizedHeader)
        }
    }

    // ===============================================================================

    private static removeFiltersFromSelectPage(userId: string) {
        const key = "products" + "-select-inventories" + "-filter-search-page-1-" + userId;
        
        localStorage.removeItem(key);
    }

    // ===============================================================================

    /**
     * Stores the necessary data for selecting inventories into local storage, then navigates
     * the user to local storage.
     */
    public static navigateToSelectInventoriesPage(userId: string, localizedHeader?: string) {
        this.storeDataInLocalStorage(localizedHeader);
        if (userId !== undefined) {
            this.removeFiltersFromSelectPage(userId);
        }
        window.location.href = `/Data/SelectInventory`;
    }
}